export class BeeyIdentityProvider {
    constructor(token) {
        this.retrieveAuthString = async () => this.token;
        this.getOutdatedAuthString = () => this.token;
        this.updateToken = async () => false;
        this.logOut = async () => { };
        this.token = token;
    }
}
